import { render } from "./TaskRowWithDropdown.vue?vue&type=template&id=2a35c105&scoped=true"
import script from "./TaskRowWithDropdown.vue?vue&type=script&lang=js"
export * from "./TaskRowWithDropdown.vue?vue&type=script&lang=js"

import "./TaskRowWithDropdown.vue?vue&type=style&index=0&id=2a35c105&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a35c105"]])

export default __exports__